import React, { useState, useMemo } from 'react';
import {
  Widget,
  GridView,
  SimpleView,
  Button,
  FormatText
} from '@digital/ui';
import FiltrosRelatorioCiclorOrcamentario from './FiltrosRelatorioCicloOrcamentario';
import { Collapse, Icon } from 'antd';
import {
  CicloOrcamentarioRelatorio,
  Filtros,
  postGetAllRelatorioCicloOrcamentarioPluriAnual
} from '../../api/relatorioCicloorcamentario'

import TableCicloOrcamentarioPluriAnualProps from './TableCicloOrcamentarioPluriAnual';
import { exportaRelatorioPluruAnualExcel } from '@app/api/relatorioProjetoPacote';

const RelatorioCicloOrcamentarioPluriAnual = () => {
  const { Panel } = Collapse;
  const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CicloOrcamentarioRelatorio>();

  const handleFilter = (filtros: Filtros) => {
    postGetAllRelatorioCicloOrcamentarioPluriAnual(filtros).then((data) => {
      setCicloOrcamentarioRelatorioTotal(data);
    });
    return true;
  }

  const hasExpostarRelatorio = (filtros: Filtros) => {
    exportaRelatorioPluruAnualExcel(filtros);
  }

  const btnExportar = () => {

    return [
      <Button
        type="primary"
        name="btnExportar"
        icon="files-ms_excel"
        onClick={() => {
          hasExpostarRelatorio({} as Filtros);
        }}>
        <FormatText id="data-export" uppercase transform={() => "Exportar Relatório"} />
      </Button>,
    ]
  }

  return (
    <SimpleView >
      <GridView noform>
        <FiltrosRelatorioCiclorOrcamentario
          onSearch={handleFilter}
          atualizarTela={() => { }} />
        {(cicloOrcamentarioRelatorioTotal) ? (
          <Widget
            title="RESULTADO"
            span={12}
            actions={btnExportar()}>
            <TableCicloOrcamentarioPluriAnualProps
              cicloOrcamentarioRelatorioTotal={cicloOrcamentarioRelatorioTotal}
              ocultarColunaDetalhe={false}
              paginacaoConfig={{
                pageSize: 25,
                onChange: (() => {
                  document.getElementById("tableCicloOrcamentarioPluriAnual").scrollIntoView();
                })
              }} />
          </Widget>
        ) : (<> </>)}
      </GridView>
    </SimpleView>
  );
};

export default RelatorioCicloOrcamentarioPluriAnual;
